export default {"src":"/_next/static/media/challenge-checkmark.7902041c.svg","height":30,"width":32,"blurWidth":0,"blurHeight":0};